import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import {
  showCameraRecorder,
  getIsVideoUploadingToBucket,
  getCampaignBanner,
  getUseCampaignBanner,
  getCampaignBrandFontColor
} from '../../redux/modules/campaignLandingPage';
import { isRecordingSupported } from '../../helpers/supportedFeatureHelper';
import { StyledBrandingButton, StyledOutlineBrandingButton } from './styles';

const VideoRecorderEnableButton = ({
  _showCameraRecorder,
  qid,
  isVideoUploading,
  backgroundColor = '',
  color = '',
  useBanner = false
}) => {
  if (!isRecordingSupported()) {
    return null;
  }
  const useCustomeStyle = useBanner && backgroundColor && color;
  const isWhitePrimaryColor = backgroundColor === 'rgb(255 255 255 / 1)';

  return isWhitePrimaryColor ? (
    <StyledOutlineBrandingButton
      component="label"
      variant="outlined"
      disabled={isVideoUploading}
      backgroundColor={backgroundColor}
      custom={useCustomeStyle}
      fontColor={color}
      sx={{ gap: '5px' }}
    >
      <Icon icon="circle" />
      Record a Video
    </StyledOutlineBrandingButton>
  ) : (
    <StyledBrandingButton
      variant="contained"
      disabled={isVideoUploading}
      onClick={() => _showCameraRecorder(qid)}
      backgroundColor={backgroundColor}
      fontColor={color}
      custom={useCustomeStyle}
      sx={{ gap: '5px' }}
    >
      <Icon icon="circle" />
      Record a Video
    </StyledBrandingButton>
  );
};

VideoRecorderEnableButton.propTypes = {
  _showCameraRecorder: PropTypes.func,
  qid: PropTypes.string,
  isVideoUploading: PropTypes.bool,
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  useBanner: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => ({
  isVideoUploading: getIsVideoUploadingToBucket(state, ownProps.qid),
  backgroundColor: getCampaignBanner(state),
  useBanner: getUseCampaignBanner(state),
  color: getCampaignBrandFontColor(state)
});

const mapDispatchToProps = {
  _showCameraRecorder: showCameraRecorder
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoRecorderEnableButton);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/VideoRecorderEnableButton.jsx